<template>
    <div class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '提示'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div v-html="content.html"></div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                styleSet: $styleSet
            }
        },
        computed: {
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                if( this.haveAction ) {
                    $results.push($action);
                }

                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content;

                $content[func]();
            },
            action: function(){
                let $content = this.content,
                    $_action = $content.action;

                if( this.haveAction ) {
                    $_action();
                }

                if( $content.actionStopClose !== true ) {
                    this.close();
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
